import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Button, Badge} from './CompareButton.styled';

const CompareButton = ({count, onClick, pulse = false}) => {
  const {t} = useTranslation();

  return (
    <Button visible={count > 0} onClick={onClick} pulse={pulse}>
      <i className="mdi mdi-scale-balance" />
      {t('compare')}
      <Badge>{count}</Badge>
    </Button>
  );
};

CompareButton.propTypes = {
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  pulse: PropTypes.bool,
};

export default CompareButton;
